import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { App } from './App';
render(<HashRouter data-id="element-116">
    <App data-id="element-117" />
  </HashRouter>, document.getElementById('root'));